import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4, 2),
    backgroundColor: theme.palette.facet.backgroundGray,
    borderRadius: theme.radius.md,
    fontSize: theme.typography.body1.fontSize,
    color: theme.palette.facet.primaryGray,
  },
});

const NoDataPlaceholderMessage = ({
  className,
  classes,
  message,
  test,
}) => {
  return (
    <div
      className={classNames(classes.root, className)}
      test={test}
    >
      <Typography
        variant="h5"
        component="p"
      >
        {message}
      </Typography>
    </div>
  );
};

NoDataPlaceholderMessage.defaultProps = {
  className: '',
  message: 'No data to display',
  test: 'table-placeholder-message',
};

NoDataPlaceholderMessage.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  message: PropTypes.string,
  test: PropTypes.string,
};

export default withStyles(styles)(NoDataPlaceholderMessage);
